import { defineComponent } from '@vue/composition-api';
export default defineComponent({
    props: {
        option: { type: Object, required: true },
        optionLabelName: { type: String, required: true },
        selected: Boolean,
        focused: Boolean,
        disabled: Boolean,
    },
    computed: {
        optionStyle() {
            const opt = this.option || {};
            return opt.style;
        },
    },
});
